import { POST } from '@/api'
import { intersection, mapValues } from 'lodash'
import { rangesToDates } from '@/utils/date'
import { toMinutes } from '@/utils/time'
import edit from './edit'

const INITIAL_DATE = {
  ranges: [],
  times: [],
}

/**
 * 予約受付時間
 */
export default {
  namespaced: true,
  state: {
    byDay: {},
    dates: [],
    busy: false,
  },
  modules: {
    edit,
  },
  mutations: {
    set(state, { day, dates }) {
      state.byDay = day
      state.dates = [].concat(dates).map(date => ({ ...INITIAL_DATE, ...date }))
    },
    busy(state, busy) {
      state.busy = busy
    },
  },
  getters: {
    bitmapByDay: ({ byDay }) =>
      mapValues(byDay, times =>
        times.reduce((bitmap, time) => {
          bitmap[Math.floor(toMinutes(time) / 15) - 6 * 4] = true
          return bitmap
        }, new Array(4 * 24).fill(false)),
      ),

    /**
     * 曜日毎の予約受付時間をランチ／ディナー別に返します
     */
    rangesByDay: (
      { byDay },
      getters,
      rootState,
      { 'stores/current/getZoneType': getZoneType, 'stores/current/canReceptTimesByDay': canReceptTimesByDay = [] },
    ) =>
      mapValues(byDay, (times, day) =>
        intersection(times, canReceptTimesByDay[day]).reduce(
          (range, time) => {
            if (getZoneType) range[getZoneType(day, time)].push(time)
            return range
          },
          { lunch: [], dinner: [] },
        ),
      ),

    /**
     * 選択済みな日付を全て返します
     * @returns {array} 日付の配列
     */
    selectedDates: ({ dates }) =>
      dates.reduce((selecteds, { ranges }) => selecteds.concat(rangesToDates(ranges)), []).sort(),
  },
  actions: {
    async get(store) {
      const { commit } = store
      commit('busy', true)

      const { status, message, data } = await POST('/api/web/reception/time')
      if (status === 200) {
        commit('set', data)
      } else {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
  },
}
